'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilitySetsEditCtrl', function ($scope, user, positions, me,
                                       pending_in_review_availability_sets, userAvailabilityChangeRequests,
                                       Session, ServerUrls, $uibModal, org, SAErrorHandler, toastr,
                                       AvailabilitySets, TimeService, $state, availabilitySet,
                                       AvailabilityRules, $interval, $filter, $timeout, UserPermissionsService) {

    $scope.user = user;
    $scope.me = me;
    $scope.org = org;
    $scope.pending_in_review_availability_sets = pending_in_review_availability_sets;
    $scope.userAvailabilityChangeRequests = userAvailabilityChangeRequests;

    $scope.active_uacr = _.find($scope.userAvailabilityChangeRequests, function(uacr) {
      return !uacr.$isExpired();
    });

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.availabilitySet = availabilitySet;


    $scope.state = {
      currentSlide: 3,
      newSlide: 3,
      skipWatches: true,
      isValid: false,
      rawPermissions: null,
      derivedPermissions: null
    };


    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;

      $scope.state.derivedPermissions = {
        canViewTarget: rawPerms['availability_sets.view_target'],
        canChangeTarget: rawPerms['availability_sets.change_target_hours'],
        canCreate: rawPerms['availability_sets.create']
      };
    }

    var permissionsToLookUp = [
      'availability_sets.edit_unsubmitted_for_self',
      'availability_sets.add_message',
      'availability_sets.view_target',
      'availability_sets.change_target_hours',
      'availability_sets.create'
    ];

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;
        processRawPermissions();
      });


    $scope.datepickers = {
      expiresInDateOpened: false
    };

    $scope.openExpiresInDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.expiresInDateOpened === true) {
        $scope.datepickers.expiresInDateOpened = false;
      } else {
        $scope.datepickers.expiresInDateOpened = true;
      }
    };

    $scope.minDate = new Date(moment().hours(0).minutes(0).seconds(0).milliseconds(0).add(moment().tz(Session.getTimezone())._offset, 'minutes').format('YYYY-MM-DD hh:mm'));

    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      showWeeks: false
    };

    $scope.formData = {
      desiredEffectiveDate: $scope.availabilitySet.desired_effective_date.toDate(),
      desired_hours: null,
      target_hours: null
    };



    $scope.unavailabilityReasons = [];
    var reasonCache = {};
    var initialReasonCache = {};

    var createReasonId = function(rule) {
      return rule.day_of_week + '_' + rule.start_time_minutes + '_' + rule.end_time_minutes;
    };

    var lookupReason = function(rule) {
      var key = createReasonId(rule);
      if (_.has(reasonCache, key)) {
        return reasonCache[key];
      } else {
        return '';
      }
    };

    var initReasonCache = function() {
      _($scope.availabilitySet.availability_rules)
        .where({avail: false})
        .each(function(rule) {
          reasonCache[createReasonId(rule)] = rule.$getLastMessage() ? rule.$getLastMessage().text : '';
          initialReasonCache[createReasonId(rule)] = rule.$getLastMessage() ? rule.$getLastMessage().text : '';
        });
    };

    initReasonCache();

    $scope.updateReason = function(rule, reason) {
      reasonCache[createReasonId(rule)] = reason;
    };

    var isEditingUnavailability = function() {
      return $scope.state.currentSlide === 3;
    };

    var isInWatchableState = function () {
      return $scope.state.currentSlide === 3 || $scope.state.currentSlide === 6;
    };

    var initTempDataByDayFromAvailabilitySet = function() {
      //console.log('initTempDataByDayFromAvailabilitySet');

      // this is the data structure that defines avail=TRUE and avail=FALSE rule objects.
      // It is not directly tied to availability_rule objects, although it may have a ruleId if originally from there
      $scope.tempDataByDay = _.map([0,1,2,3,4,5,6], function(dayIndex) {
        var temp = {
          dayIndex: dayIndex,
          objects: _.map(_.sortBy(_.where($scope.availabilitySet.availability_rules, function(rule) {
            return rule.active && rule.day_of_week === dayIndex;
          }), 'start_time_minutes'), function(rule) {
            var rawText = TimeService.minutesToTimeString(rule.start_time_minutes, true) + '-' +
                TimeService.minutesToTimeString(rule.end_time_minutes, true);
            return {
              ruleId: rule.id,
              rawText: rawText,
              avail: rule.avail,
              parseData: TimeService.parseRawStartEndTimeString(rawText, $scope.currentDate),
              reasonText: rule.messages && rule.messages.length > 0 ? _.last(rule.messages).text : ''
            };
          })
        };
        //console.log(temp.dayIndex, temp.objects);
        return temp;
      });
    };

    initTempDataByDayFromAvailabilitySet();
    //console.log('tempDataByDay', $scope.tempDataByDay);

    var calculateAvailByDayOfWeek = function() {
      //console.log('calculateAvailByDayOfWeek');
      $scope.preferredHours = 0;
      $scope.unavailableHours = 0;

      $scope.availabilityByDay = {};
      $scope.availByDayOfWeek = [[], [], [], [], [], [], []];

      _.forEach($scope.fluidAvailabilitySet.availability_rules, function(rule) {
        //console.log(rule.range_twix.format());
        if (rule.active && rule._type === 'weekly') {
          if (_.has($scope.availabilityByDay, rule.day_of_week)) {
            //console.log('n) pushing rule ' + rule.id + ' onto ' + rule.day_of_week);
            $scope.availabilityByDay[rule.day_of_week].push(rule);
          } else {
            //console.log('1) pushing rule ' + rule.id + ' onto ' + rule.day_of_week);
            $scope.availabilityByDay[rule.day_of_week] = [rule];
          }

          // take the length of the interval and add it by avail or not
          if (rule.avail) {
            $scope.preferredHours += rule.range_twix.length('minutes') / 60.0;
          } else {
            $scope.unavailableHours += rule.range_twix.length('minutes') / 60.0;
          }
        }
      }, this);

      _.forEach([0,1,2,3,4,5,6], function(dayNum) {
        if (_.has($scope.availabilityByDay, dayNum)) {
          $scope.availByDayOfWeek[dayNum] = $scope.availabilityByDay[dayNum];
        }
      });
    };

    var calculateAllDays = function() {
      //console.log('calculateAllDays');

      // this represents what will be painted in the input boxes and squares below the input boxes
      // it is filtered based on the current Slide number
      $scope.allDays = _.map([0,1,2,3,4,5,6], function(dayIndex) {
        var temp = {
          dayIndex: dayIndex,
          objects: _.map(_.where($scope.tempDataByDay[dayIndex].objects, function(obj) {
            return obj.avail === !isEditingUnavailability();
          }), function(obj) {
            return TimeService.parseRawStartEndTimeString(obj.rawText, $scope.currentDate);
          })
        };

        temp.rawText = _.map(temp.objects, function(obj) {
          return obj.rawText;
        }).join(', ');

        return temp;
      });
    };

    calculateAllDays();

    var createAvailabilitySetDataForDisplay = function() {
      // need to take in tempDataByDay and create availability_rules
      var ruleData = {
        recurring: true,
        repeats_on_weekly: '1',
        active: true,
        user_id: $scope.user.id,
        organization_id: $scope.availabilitySet.organization_id,
        start_date: moment.utc().format()
      };

      // check to see if any of time ranges are multi-day,
      // if so, split them in tempDataByDay.

      return _.flatten(_.map($scope.tempDataByDay, function(dayData) {
        return _.where(_.map(dayData.objects, function(obj) {
          if (obj.parseData.parsed) {
            var rule = AvailabilityRules.initWithData(_.extend(_.cloneDeep(ruleData), {
              id: obj.ruleId,
              start_time_minutes: obj.parseData.start.hour * 60 + obj.parseData.start.min,
              end_time_minutes: obj.parseData.end.hour * 60 + obj.parseData.end.min,
              day_of_week: dayData.dayIndex,
              avail: obj.avail,
              _originating: {
                rawText: obj.rawText,
                day_of_week: dayData.dayIndex
              },
              comment: obj.reasonText
            }));

            if (rule.start.day() !== rule.end.day() && ((rule.end.hour() * 60 + rule.end.minute()) !== 0)) {
              // break the rules because we have encountered a scenario like 4p-12:15a or 4p-2a
              return [
                AvailabilityRules.initWithData(_.extend(_.cloneDeep(ruleData), {
                start_time_minutes: obj.parseData.start.hour * 60 + obj.parseData.start.min,
                end_time_minutes: 24 * 60,
                day_of_week: dayData.dayIndex,
                avail: obj.avail,
                _originating: {
                  rawText: obj.rawText,
                  day_of_week: dayData.dayIndex
                }
              })),
                AvailabilityRules.initWithData(_.extend(_.cloneDeep(ruleData), {
                  start_time_minutes: 0,
                  end_time_minutes: obj.parseData.end.hour * 60 + obj.parseData.end.min - 24 * 60,
                  day_of_week: dayData.dayIndex !== 6 ? dayData.dayIndex + 1 : 0,
                  avail: obj.avail,
                  _originating: {
                    rawText: obj.rawText,
                    day_of_week: dayData.dayIndex
                  }
                }))
              ]
            } else {
              return [rule];
            }
          } else {
            return false;
          }
        }, function(x) {
          return x !== false;
        }));
      }));
    };

    $scope.fluidAvailabilitySet = {
      availability_rules: createAvailabilitySetDataForDisplay()
    };

    _.each($scope.allDays, function(day, idx) {
      $scope.$watch(function() {
        return $scope.allDays[idx].rawText;
      }, (function (idx) {
        return function (newVal) {
          if ( !$scope.state.skipWatches && isInWatchableState()) {
            //console.log('WATCH FIRED: ', idx, ': ', newVal);
            var res = parseRawText(newVal);

            $scope.allDays[idx].objects = res;
            // now I need to merge the tempDataByDay[idx] objects and $scope.allDays[idx] objects
            // depending on the current viewMode I drop avail=true or avail=false

            var tempObjects = $scope.tempDataByDay[idx].objects;
            tempObjects = _.where(tempObjects, function(obj) {
              return obj.avail === isEditingUnavailability();
            });

            tempObjects.push.apply(tempObjects, _.map($scope.allDays[idx].objects, function(obj) {
              return {
                ruleId: undefined,
                rawText: obj.rawText,
                avail: !isEditingUnavailability(),
                parseData: obj
              }
            }));

            $scope.tempDataByDay[idx].objects = tempObjects;


            $scope.fluidAvailabilitySet.availability_rules = createAvailabilitySetDataForDisplay();
            calculateAvailByDayOfWeek();
            validateRules();

          }


//            calcTotalShifts();
          };
      })(idx));
    });



    var parseRawText = function(rawText) {
      // first, just split it on comma and get an array of possibilities.
      // trim whitespace off of both sides
      var entries = _.invoke(rawText.split(','), 'trim');

      // only take entries that are length 1 or greater once trimmed
      entries = _.where(entries, function(entry) {
        return entry.length >= 1;
      });

      var processedEntries = _.map(entries, function(entry) {
        return TimeService.parseRawStartEndTimeString(entry, $scope.currentDate);
      });

      return processedEntries;
    };


    $scope.$on('availabilitySet:fluidAvail:removal', function(event, data) {
      // data is a rule
      // we have to figure out which rule it is since we don't have ID's here...
      event.stopPropagation();

      // based on data.day_of_week look through tempDataByDay and find the matching rule
      var matchingRuleIdx = _.findIndex($scope.tempDataByDay[data._originating.day_of_week].objects, function(rule) {
        return rule.avail === data.avail &&
               rule.rawText === data._originating.rawText;
      });

      if (matchingRuleIdx > -1) {
        $scope.tempDataByDay[data._originating.day_of_week].objects.splice(matchingRuleIdx, 1);
        calculateAllDays();
        $scope.fluidAvailabilitySet.availability_rules = createAvailabilitySetDataForDisplay();
        calculateAvailByDayOfWeek();
        validateRules();
      }

    });

    $scope.removeRule = function(rowIdx, objIdx) {
      var allEntries = _.pluck($scope.allDays[rowIdx].objects, 'rawText');
      allEntries.splice(objIdx, 1);
      $scope.allDays[rowIdx].rawText = allEntries.join(', ');
    };

    var validateRules = function() {
      // look over all of the days, then loop over all of the rules for +/- 1 day and check for overlap

      var allIntervals = _.flatten(_.map($scope.tempDataByDay, function(day, idx) {
        var offset = idx * 24 * 60;
        return _.map(_.where(day.objects, function(x) { return x.parseData.parsed;}), function(obj, idy) {
          var itv = [offset + obj.parseData.start.hour * 60 + obj.parseData.start.min, offset + obj.parseData.end.hour * 60 + obj.parseData.end.min];
          if (idx === 6 && itv[1] > (offset + 24 * 60)) {
            return [
              {
                dayIndex: idx,
                objIndex: idy,
                rawText: obj.rawText,
                interval: [itv[0], offset + 24 * 60]
              },
              {
                dayIndex: idx,
                objIndex: idy,
                rawText: obj.rawText,
                interval: [0, itv[1] - (offset + 24 * 60)]
              }
            ]
          } else {
            return {
              dayIndex: idx,
              objIndex: idy,
              rawText: obj.rawText,
              interval: itv
            };
          }

        });
      }));

      var sortedIntervals = _.sortBy(allIntervals, function(obj) {
        return obj.interval[0];
      });

      var violations = [null, null, null, null, null, null, null];

      _.each(sortedIntervals, function(obj, idx) {
        if (idx > 0) {
          // check if obj.interval[0] if < sortedIntervals[idx-1].interval[1]
          if (obj.interval[0] < sortedIntervals[idx-1].interval[1]) {
            violations[obj.dayIndex] = {
              objects: [obj, sortedIntervals[idx-1]],
              dayIndexToShowOn: obj.dayIndex,
              text: 'Entry ' + sortedIntervals[idx-1].rawText + ' on ' + $filter('dayNumberToWords')(sortedIntervals[idx-1].dayIndex) + ' overlaps with entry ' + obj.rawText + ' on ' + $filter('dayNumberToWords')(obj.dayIndex)
            };
          }
        }
      });

      $scope.violationByDay = lodash.cloneDeep(violations);
      $scope.allViolations = lodash.cloneDeep(violations)
      lodash.remove($scope.allViolations, function (err) {
        return err === null
      })

      $scope.state.isValid = _.all(violations, function(v) {
        return _.isNull(v);
      });
    };

    var processDate = function(dt) {
      var tzOffsetInMinutes = moment(dt).tz(Session.getTimezone())._offset;
      var theTime = moment(dt).tz(Session.getTimezone()).add(tzOffsetInMinutes, 'minutes');
      theTime.hour(dt.getHours()).minute(dt.getMinutes());

      return theTime;
    };


    $scope.canAutoApprove = (function() {
      return $scope.availabilitySet.availability_change_request_id ?
          !$scope.availabilitySet.availability_change_request.approval_required
          : ($scope.org.organization_config.recurring_availability_approval_required === 0);
    })();

    $scope.saveSet = function(submitNow, redirectNow) {
      // check if all rules are valid
      if (!$scope.state.isValid) {
        toastr.error('Whoops! Looks like you have some overlapping rules. Please go back and fix them.', 'Error');
        return;
      }

      // do this by process of elimination. Any sets that match leave alone.
      // any rules left in availabilitySet.availability_rules get removed
      // any rules left in fluidAvailabilitySet.availability_rules get created

      var initialRules = _.cloneDeep($scope.availabilitySet.availability_rules);
      var fluidRules = _.cloneDeep($scope.fluidAvailabilitySet.availability_rules);

      _.each(initialRules, function(ir) {
        _.each(fluidRules, function(fr) {
          if (ir.avail === fr.avail && ir.day_of_week === fr.day_of_week &&
              ir.start_time_minutes === fr.start_time_minutes && ir.end_time_minutes === fr.end_time_minutes) {
            ir._matchFound = fr;
            fr._matchFound = ir;
          }
        });
      });

      var rulesToRemove = _.where(initialRules, function(ir) {
        return _.isUndefined(ir._matchFound);
      });

      var availabilityRuleIdsRemoved = _.pluck(rulesToRemove, 'id');

      var rulesToCreate = _.where(fluidRules, function(fr) {
        return _.isUndefined(fr._matchFound);
      });

      var rulesToUpdateMessages = _.where(fluidRules, function(fr) {
        return !fr.avail && !_.isUndefined(fr._matchFound);
      });

      var availabilityRulesToCreate = _.map(rulesToCreate, function(rule) {
        var data = _.pick(rule, ['day_of_week', 'organization_id', 'user_id', 'start_time_minutes',
                              'end_time_minutes', 'avail', 'recurring', 'repeats_on_weekly', 'active', 'start_date', 'comment']);

        //data['message'] = _.clone(data['comment']);
        data['message'] = lookupReason(rule);
        data['comment'] = undefined;
        return data;
      });


      var desired = ($scope.state.derivedPermissions.canCreate && $scope.state.derivedPermissions.canChangeTarget) ? $scope.formData.target_hours : $scope.formData.desired_hours

      if (!desired) {

        if ($scope.state.derivedPermissions.canCreate && $scope.state.derivedPermissions.canChangeTarget) {
          toastr.error('You must provide a target number of hours.', 'Target Hours Missing')
        } else {
          toastr.error('You must provide a desired number of hours.', 'Desired Hours Missing')
        }
        return
      }
      if (desired < 0) {
        toastr.error('Whoops! You can\'t work less than 0 hours.', 'Desired Hours Less than Zero')
        return
      }

      var updateData = {
        state: AvailabilitySets.stateMapping.PENDING,
        desired_effective_date: processDate($scope.formData.desiredEffectiveDate).format(),

        // if user has permission to create and change target hours in availability_sets for anyone in org, then set the target to desired here
        desired_hours: desired,
        target_hours: $scope.formData.target_hours,
        availability_rules: availabilityRulesToCreate,
        availability_rule_ids_to_remove: availabilityRuleIdsRemoved
      };

      if (!_.isUndefined(submitNow)) {
        updateData.state = $scope.canAutoApprove ? AvailabilitySets.stateMapping.APPROVED : AvailabilitySets.stateMapping.IN_REVIEW;
      }

      var updatedFlags = {
        availSet: false
      };

      var checkIfUpdatedAndRedirect = function() {
        if (_.all(updatedFlags)) {
          if (redirectNow) {
            $state.go('profile.availability.sets.view', {userId: $scope.user.id, setId: $scope.availabilitySet.id});
          }
        }
      };

      _.each(rulesToUpdateMessages, function(rule) {
        // if there is a matching reasonId then check it against the current value, if it's different then update
        var reasonId = createReasonId(rule);
        var isInitialMatch = _.has(initialReasonCache, reasonId);

        if (!isInitialMatch || (isInitialMatch && initialReasonCache[reasonId] !== reasonCache[reasonId])) {
          rule.id = rule._matchFound.id;
          updatedFlags[rule.id] = false;

          rule.$update({
            reason: lookupReason(rule)
          }).then(function() {
            updatedFlags[rule.id] = true;

            checkIfUpdatedAndRedirect();
          }, function(response) {
            SAErrorHandler.processError(response);
          });

        }
      });


      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
            initTempDataByDayFromAvailabilitySet();
            calculateAllDays();
            $scope.fluidAvailabilitySet.availability_rules = createAvailabilitySetDataForDisplay();
            calculateAvailByDayOfWeek();
//              validateRules();
            updatedFlags.availSet = true;
            checkIfUpdatedAndRedirect();

          }, function(response) {
            console.log('that didn\'t go as planned');
            console.log(response);
            SAErrorHandler.processError(response);
          });
    };

    $scope.submitForReview = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.IN_REVIEW
      };

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function(response) {
          SAErrorHandler.processError(response);
          });
    };


    $scope.approveSet = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.APPROVED
      };

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function(response) {
            SAErrorHandler.processError(response);
          });
    };

    $scope.disapproveSet = function() {
      var updateData = {
        state: AvailabilitySets.stateMapping.DISAPPROVED
      };

      $scope.availabilitySet.$update(updateData)
          .then(function(response) {
            $scope.availabilitySet = response;
          }, function(response) {
            SAErrorHandler.processError(response);
          });
    };

      $scope.sectionTitles = [
        {
          name: 'Intro',
          className: 'start'
        },
        {
          name: 'Set Date',
          className: 'when'
        },
        {
          name: 'Which Set',
          className: 'which'
        },
        {
          name: 'Unavailable',
          className: 'unavailable'
        },
        {
          name: 'Reasons',
          className: 'reasons'
        },
        {
          name: 'Available',
          className: 'available'
        },
        {
          name: 'Prefer',
          className: 'prefer'
        },
        {
          name: 'Review',
          className: 'review'   // include employee desired hours
        }
      ];


      $scope.goToNext = function() {
        $scope.goToState($scope.state.currentSlide + 1);
      };

      $scope.goToPrev = function() {
        $scope.goToState($scope.state.currentSlide - 1);
      };

      var transitionTimeout;
      var animationTimeout;


      var detectTemplateLoadedInterval = $interval(function() {
        if( $('.slide-wrapper').length > 0 ) {
          $scope.goToState($scope.state.currentSlide, true);
        }
      }, 10);

      $scope.goToState = function(newState, goNow) {
        console.log(newState, goNow);
        if (newState < 0) {
          newState = 0;
        }

        $scope.state.newSlide = newState;

        if (!_.isUndefined(detectTemplateLoadedInterval)) {
          $interval.cancel(detectTemplateLoadedInterval);
          detectTemplateLoadedInterval = undefined;
        }

        // Wait for a small amount of time before animating to
        // allow the target slide directive to instantiate
        animationTimeout = $timeout(function () {
          if (!_.isUndefined(goNow)) { // If we loaded to a specific state, do not animate
            $('.slide-wrapper').css({
              left: (newState - 3) * -823
            });
          } else { // If we clicked a button, animate
            $('.slide-wrapper').animate({
              left: (newState - 3) * -823
            }, 300);
          }
        }, 50);

        // Create transitioning timer so current slide doesn't
        // disappear at start of animation
        if (!_.isUndefined(transitionTimeout)) {
          $timeout.cancel(transitionTimeout);
        }
        transitionTimeout = $timeout(function () {
          $scope.state.currentSlide = newState;

          $scope.state.skipWatches = true;

          if (isInWatchableState()) {
            calculateAllDays();
            $scope.fluidAvailabilitySet.availability_rules = createAvailabilitySetDataForDisplay();
            validateRules();
          }

          // if we're on the Reasons page then preset all of the right fields :-)
          if (newState === 4) {
            $scope.unavailabilityReasons = _($scope.fluidAvailabilitySet.availability_rules)
              .where({avail: false})
              .map(function(rule) {
                return {
                  id: createReasonId(rule),
                  reason: lookupReason(rule),
                  rule: rule
                }
              }).value();
          }
          $scope.state.skipWatches = false;
        }, 300);

      };

      $scope.displaySlide = function(slide) {
        return $scope.state.currentSlide === slide || $scope.state.newSlide === slide;
      };

    $scope.state.skipWatches = false;
  });
